import React, { createRef, useEffect, useState, useMemo } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import TableUi from "../../components/Layout/TableUI";
import TableFilterBox from "../../components/common/TableFilterBox";
import ContentValidation from "../../components/common/ContentValidation";
import {
  Pagination,
  RangePicker,
  SelectInput,
  TextInput,
} from "../../components/globals";
import { Button, Checkbox, DatePicker, Form, Input, Select } from "antd";
import ClientInfoComponent from "../../components/Repetitive_components/clientInfoComponent";
import {
  antdMessageError,
  antdMessageSuccess,
  formatDatePlus,
  getDateFormat,
  returnEuroString,
} from "../../helpers/Utils";
import { IconDot, IconEdit, IconRollBack } from "../../components/Layout/Icons";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../helpers/FunctionsGlobal";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useMutation,
} from "react-query";
import ModalLostCart from "../../components/lost_cart/ModalLostCart";
import Axios from "axios";
import { getCommentStateOption } from "../../redux/Actions/comment_StateAction";
import { useDispatch, useSelector } from "react-redux";
import useChecked from "../../hooks/useChecked";
import CourierLinksComponent from "../../components/Repetitive_components/courierLinksComponent";
import { useFetch, useModal, usePagination } from "../../hooks";
import { labelTranslates } from "../../utils/filtering";
import { getOrder, updateOrderAddress } from "../../redux/Actions/orderAction";
import RegularOrderChildren from "../../components/common/GlobalModals/Orders/RegularOrderChildren";
import ModalSpecial from "../../components/Layout/Modals/ModalSpecial";
import MoneyRefundOrderRowPreview from "../../components/common/GlobalModals/Orders/editModal/Payments/MoneyRefundOrderRowPreview";
import { BillingFormOld } from "../../components/common/GlobalModals/Orders/editModal/billingAddress";
import { colors } from "../../utils/colors";
import { capitalizeFirstLetter } from "../../utils/string";
import { HiDocument } from "react-icons/hi";
import TableComment from "../../components/orders/accepted_orders/items/TableComment";
import { paymentDetailsAutoFill } from "../../helpers/order";
import ShipmentStoreSvg from "../../../assets/images/shipment/shipment_store.svg";
import { removeDuplicates } from "../../helpers/array";
import ShipmentComponentReturn from "../../components/orders/accepted_orders/items/ShipmentComponentReturn";
import { setParcelTerminalsOptions } from "../../redux/Actions/options_action";
import { setPickupAddressesOptions } from "../../redux/Actions/options_action";
import { formatDateTime } from "../../utils/date";
import { have_product_reference } from "../../helpers/OrdersFunctionsGlobal";

const initialFilters = {
  order_id_order_eq: null,
  order_customer_firstname_or_order_customer_lastname_or_order_customer_email_or_order_customer_company_code_cont_any:
    "",
  order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont:
    "",
  order_carrier_name_in: "",
  supplier_id_eq: "",
  created_at: ["", ""],
  status_eq: null,
  return_type_eq: null,
  order_comments_body_cont: "",
  logistic_comments_body_cont: "",
};

export const queryLostCartsClient = new QueryClient();

const fetchLostCarts = async ({ queryKey }) => {
  const [key, { page, perPage, filterStr }] = queryKey;
  const response = await Axios.get(
    `/api/v1/${key}?page=${page}&per_page=${perPage}${filterStr}`
  );
  return response.data;
};
function ReturnsPage({ match }) {
  const { value: suppliers } = useFetch(
    "/api/v1/suppliers",
    {},
    [],
    (value) => {
      return value.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
    }
  );
  const modalRef = createRef();
  const dispatch = useDispatch();

  const { order_shops } = useSelector((state) => state.options);
  const { currentPage, currentPerPage, setCurrentPage, setCurrentPerPage } =
    usePagination();

  const [filters, setFilters] = useState(initialFilters);
  const [filterStr, setFilterStr] = useState("");
  const [previewCart, setPreviewCart] = useState(null);
  const {
    isLoading,
    isRefetching,
    error,
    refetch,
    data: { totals = 0, data = [] } = {},
  } = useQuery({
    queryKey: [
      "order_returns",
      { page: currentPage, perPage: currentPerPage, filterStr },
    ],
    queryFn: fetchLostCarts,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });

  const { modalOpt, setModalOpt, closeModal } = useModal();

  const { data: { data: comment_states } = [] } = useQuery({
    queryKey: ["comment_states"],
    queryFn: getCommentStateOption,
    staleTime: 10000,
  });

  const { onChangeChecked, checkedIncluded, checkedAll, setChecked, checked } =
    useChecked([]);

  const mutationFinishOrder = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/lost_carts/${record_id}/finish_order`,
        method: "POST",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
      setPreviewCart(null);
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const mutationDelete = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/lost_carts/${record_id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
      setPreviewCart(null);
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  useEffect(() => {
    dispatch(setParcelTerminalsOptions());
    dispatch(setPickupAddressesOptions());
    refetch();
  }, [dispatch]);

  return (
    <Container
      location={{
        locationName: "Returns",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          page={currentPage}
          countPage={currentPerPage}
          totals={totals}
          loading={isLoading || isRefetching}
          length={data?.length}
          text2="Returns"
          onChangeCountPage={setCurrentPerPage}
        />
      </ContentBlock>
      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            if (generateParams(filters) == filterStr && currentPage == 1) {
              return refetch();
            }
            setFilterStr(generateParams(filters));
            setCurrentPage(1);
          }}
          add={false}
          clearFilter={() => setFilters(initialFilters)}
        >
          {Object.entries(filters).map(([key, value]) => (
            <React.Fragment key={key}>
              {["status_eq", "supplier_id_eq"].includes(key) ? (
                <div className="px-1">
                  <SelectInput
                    options={
                      key == "status_eq"
                        ? [
                          {
                            label: "New",
                          },
                          {
                            label: "Returned to office",
                          },
                          {
                            label: "Returned to also",
                          },
                        ].map((s) => ({
                          label: s.label,
                          value: s.label.split(" ").join("_").toLowerCase(),
                        }))
                        : suppliers
                    }
                    label={labelTranslates[key]}
                    name={key}
                    style={{ width: 165 }}
                    value={value || undefined}
                    onChange={(value) =>
                      setFilters((prev) => ({
                        ...prev,
                        [key]: value,
                      }))
                    }
                  />
                </div>
              ) : key == "created_at" ? (
                <div className="px-1">
                  <RangePicker
                    label={labelTranslates[key]}
                    style={{ width: 250 }}
                    value={
                      !!value
                        ? [getDateFormat(value[0]), getDateFormat(value[1])]
                        : []
                    }
                    onChange={(_, args) => {
                      setFilters((prev) => ({
                        ...prev,
                        [key]: args,
                      }));
                    }}
                  />
                </div>
              ) : key == "return_type_eq" ? (
                <div className="px-1">
                  <SelectInput
                    with_empty
                    options={[
                      {
                        label: "Rma",
                        value: "Rma",
                      },
                      {
                        label: "Logistics",
                        value: "Logistics",
                      },
                    ]}
                    label={labelTranslates[key]}
                    style={{ width: 165 }}
                    name={key}
                    value={value || undefined}
                    onChange={(value) =>
                      setFilters((prev) => ({
                        ...prev,
                        [key]: value,
                      }))
                    }
                  />
                </div>
              ) : (
                <div className="px-1">
                  <TextInput
                    text={labelTranslates[key]}
                    name={key}
                    value={value}
                    style={{ width: 165 }}
                    onKeyDown={handleKeyDown2(() => {
                      if (
                        generateParams(filters) == filterStr &&
                        currentPage == 1
                      ) {
                        return refetch();
                      }
                      setFilterStr(generateParams(filters));
                      setCurrentPage(1);
                    })}
                    onChange={onChangeUseState(setFilters)}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </TableFilterBox>
        <ContentValidation
          loader={isLoading || isRefetching}
          array={data}
          error={error}
        >
          <TableUi
            responsive
            ths={[
              <Checkbox
                checked={checkedAll(data.map(({ id }) => id))}
                onChange={() =>
                  setChecked(
                    checkedAll(data.map(({ id }) => id))
                      ? []
                      : data.map(({ id }) => id)
                  )
                }
              />,
              "Order no.",
              "Client",
              "Goods",
              "Delivery",
              "Called courier information",
              "Division",
              "Formation of document",
              "Status",
              "Return type",
              "Refund module",
              "KA comments",
              "Manager comments",
              "Logistic comments",
            ]}
          >
            {data.map((record) => {
              return (
                <ReturnItem
                  key={record.id}
                  record={record}
                  refetch={refetch}
                  isLoading={isLoading || isRefetching}
                  checkedIncluded={checkedIncluded(record.id)}
                  onChangeChecked={() => onChangeChecked(record.id)}
                  mutationFinishOrder={mutationFinishOrder}
                  mutationDelete={mutationDelete}
                  setModalOpt={(type, record_id, record) => {
                    if (type == "order") {
                      dispatch(getOrder(record_id));
                      modalRef.current.openModal("OrderShowModal");
                    }
                    setModalOpt(type, record_id, record);
                  }}
                />
              );
            })}
          </TableUi>
        </ContentValidation>
        <div className="mt-4">
          <Pagination
            page={currentPage}
            setPagination={setCurrentPage}
            totals={totals}
            pageCount={currentPerPage}
          />
        </div>
      </ContentBlock>
      {typeof previewCart == "number" && (
        <ModalLostCart
          lost_cart_id={previewCart}
          close={() => {
            refetch();
            setPreviewCart(null);
          }}
          comment_states={comment_states}
          mutationFinishOrder={mutationFinishOrder}
          mutationDelete={mutationDelete}
        />
      )}
      <React.Fragment>
        <div id="modal-roots" />
        <RegularOrderChildren
          ref={modalRef}
          requiredOrderId={modalOpt?.record?.id_order}
        />
      </React.Fragment>
      {modalOpt?.type == "formation_of_document" && (
        <ModalFormationOfDocument
          order_return_id={modalOpt.record_id}
          record={modalOpt.record}
          onClose={closeModal}
        />
      )}
      {modalOpt?.type == "refund_module" && (
        <ModalRefundModule
          order_return_id={modalOpt.record_id}
          record={modalOpt.record}
          onClose={closeModal}
        />
      )}
    </Container>
  );
}

const ModalRefundModule = ({ order_return_id, record, onClose }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [addressEdit, setAddressEdit] = useState(false);
  const [recordState, setRecordState] = useState(record);

  const { billing_address, payments, order_cart_rules } = recordState.order;

  const fetchData = async (order_id) => {
    const res = await Axios.get(`/api/v1/order_returns/${order_id}`);
    setRecordState(res.data.data.find((order) => order.id === record.id));
  };

  useEffect(() => {
    fetchData(record.order_id);
  }, [record]);

  useEffect(() => {
    const { customer, bank_account } = paymentDetailsAutoFill({
      billing_address,
      payments,
    });
    form.setFieldsValue({ customer, bank_account });
  }, [billing_address]);

  const manual_cart_items = order_cart_rules.filter(
    (item) => item.id_product === null || item.identifier === "manual_cart"
  );
  const total_discount = manual_cart_items.reduce(
    (sum, item) => sum + parseFloat(item.total),
    0
  );

  useEffect(() => {
    form.setFieldsValue({ total_discount });
  }, [total_discount]);

  const order_rows_selected = Form.useWatch("order_rows", form);

  const mutationCreate = useMutation({
    mutationFn: (params) =>
      Axios.post(`/api/v1/money_refunds`, params).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.errors?.order_rows);
      if (error?.response?.data?.errors) {
        Object.entries(error?.response?.data?.errors).map(([name, errors]) => {
          form.setFields([{ name, errors }]);
        });
      }
    },
  });

  const o_rows = recordState.order_row_returns
    .map(({ order_row }) => order_row)
    .filter(Boolean);

  const procutsWithDelivery = () => {
    const hasNullId = recordState.order_row_returns.some(
      (order_row) => order_row.title === "Delivery"
    );
    const service_shiping = {
      unit_price_tax_incl: parseInt(hasNullId?.price || 0),
      total_shipping_tax_incl: parseInt(hasNullId?.price || 0),
      product_name: "Delivery",
      id: "delivery",
      quantity: 1,
    };
    const porductsArray = recordState.order_row_returns
      .map(({ order_row }) => order_row)
      .filter(Boolean);

    if (hasNullId) porductsArray.push(service_shiping);

    return porductsArray;
  };

  return (
    <ModalSpecial
      style={{
        width: 500,
      }}
      text={
        <span className="d-flex align-items-center justify-content-between w-100">
          <div>
            <span className="font-bold text-xl text-black">Return</span>
            <span className="font-bold text-xl text-primary pl-1">#</span>
            <span className="font-bold text-xl text-black pr-1">
              {order_return_id}
            </span>
            <span className="font-bold text-xl text-black">order moneys</span>
          </div>
        </span>
      }
      onClose={() => {
        onClose();
      }}
    >
      <div className="border-silver border-radius-base px-2 pt-1 pb-3">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="font-medium text-base text-black">
            Payer information
          </h5>
          <IconEdit
            className="text-xl cursor-pointer"
            onClick={() => setAddressEdit((prev) => !prev)}
          />
        </div>
        {addressEdit ? (
          <BillingFormOld
            billing_address={billing_address}
            customAction={(params) =>
              dispatch(updateOrderAddress(recordState.order.id, params)).then(
                (response) => {
                  console.log({ response });
                  setAddressEdit(false);
                }
              )
            }
          />
        ) : (
          <ul className="list-style-none text-base">
            <li>
              {billing_address.firstname} {billing_address.lastname}
            </li>
            {billing_address.company && <li>{billing_address.company}</li>}
            {billing_address.company_code && (
              <li>{billing_address.company_code}</li>
            )}
            {billing_address.vat_code && (
              <li>PVM: {billing_address.vat_code}</li>
            )}
            <li>{billing_address.street}</li>
            {billing_address.street2 !== null && (
              <li>{billing_address.street2}</li>
            )}
            <li>
              {billing_address?.country &&
                `${billing_address.country.en_name}, `}
              {billing_address.city}, {billing_address.postal_code}
            </li>
            <li className={!!billing_address.phone ? "" : "text-danger"}>
              {billing_address.phone}
            </li>
            <li>{billing_address.other}</li>
          </ul>
        )}
      </div>
      <div className="font-base text-base mt-3">Returning products</div>
      <Form
        form={form}
        layout="vertical"
        name="basic"
        initialValues={{
          date: "",
          reason: "",
          bank_account: "",
          bank_name: "Swedbank",
          sum: "",
          order_rows: o_rows,
          shipping:
            recordState.order_row_returns.find((s) => s.title == "Delivery")
              ?.price || 0,
          // order_rows: [record.order_row.id],
          total_product: "",
          order_cart_rules: [],
          total_discount: "",
          customer: "",
        }}
        requiredMark={<div className="text-primary">*</div>}
        onFinish={(variables) => {
          const {
            date,
            bank_name,
            bank_account,
            reason,
            sum,
            order_rows,
            order_cart_rules,
            customer,
            total_discount,
            total_product,
          } = variables;
          if (!date) return antdMessageError("Choise date");
          if (!bank_name) return antdMessageError("Choise bank");
          if (+sum <= 0 && order_cart_rules.length > 0)
            return antdMessageError(
              "[Total amount]: It cannot be less than or equal to 0"
            );
          const hasDelivery = recordState.order_row_returns.find(
            (order_row) => order_row.title === "Delivery"
          );
          const params = {
            date,
            bank_name,
            order_shop_id: recordState.order.order_shop_id,
            order_return_id: order_return_id,
            money_refund_item: {
              reason,
              sum,
              order_rows: order_rows
                .filter((row) => typeof row === "object" && row.id !== null)
                .map((row) => row.id),
              shipping: hasDelivery
                ? Number.parseFloat(hasDelivery.price) || 0
                : 0,
              total_discount,
              total_product,
              order_cart_rules,
              bank_account: bank_account.toUpperCase(),
              order_id: recordState.order_id,
              customer,
              refund_type: "products",
            },
          };
          mutationCreate.mutate(params);
        }}
        autoComplete="off"
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridColumnGap: 5,
          }}
        >
          <Form.Item
            label="Return date"
            name="date"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <DatePicker
              style={{
                width: "100%",
              }}
              placeholder="Select"
            />
          </Form.Item>
          <Form.Item
            label="Bank"
            name="bank_name"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Select>
              <Select.Option value="Swedbank">Swedbank</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Customer"
            name="customer"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input placeholder=" type in" />
          </Form.Item>
          <Form.Item
            label="Reason"
            name="reason"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input placeholder=" type in" />
          </Form.Item>
        </div>
        <div className="ant-form-item">
          <div className="text-bold my-1 ">
            Products <span className="orange_color">*</span>
          </div>
          <div className="bg-light-primary rounded">
            <MoneyRefundOrderRowPreview
              order_cart_rules={[]}
              o_rows={procutsWithDelivery()}
              order_rows_selected={order_rows_selected || []}
              setValue={(val) => {
                form.setFieldsValue({
                  total_product: val.sum,
                  order_rows: val.order_rows,
                });
                // onChange("total_product", val.sum);
                // onChange("order_rows", val.order_rows);
              }}
            />
          </div>
        </div>
        <Form.Item name="order_rows" label="Order rows" className="d-none">
          <Input />
        </Form.Item>
        <Form.Item
          name="order_cart_rules"
          label="order_cart_rules"
          className="d-none"
        >
          <Input />
        </Form.Item>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gridColumnGap: 5,
          }}
        >
          <Form.Item
            label="Total product/service"
            name="total_product"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input
              placeholder="type in"
              suffix="€"
              onChange={(e) => {
                const { value } = e.target;
                form.setFieldsValue({
                  sum: +value - +form.getFieldValue("total_discount"),
                });
              }}
            />
          </Form.Item>
          <Form.Item
            label="Total discount"
            name="total_discount"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input
              placeholder="type in"
              suffix="€"
              onChange={(e) => {
                const { value } = e.target;
                form.setFieldsValue({
                  sum: +form.getFieldValue("total_product") - +value,
                });
              }}
            />
          </Form.Item>
          <Form.Item
            label="Total Amount"
            name="sum"
            rules={[
              {
                required: true,
                message: "Can't be empty",
              },
            ]}
          >
            <Input disabled={true} suffix="€" placeholder="type in" />
          </Form.Item>

          <Form.Item
            label="Bank account number"
            name="bank_account"
            rules={[
              {
                required: true,
                message: "Please input bank account number",
              },
            ]}
          >
            <Input placeholder=" type in" />
          </Form.Item>
          <div></div>
          <Form.Item className="mt-auto">
            <Button
              loading={mutationCreate.isLoading}
              className="w-100"
              type="primary"
              htmlType="submit"
            >
              Create
            </Button>
          </Form.Item>
        </div>
      </Form>
    </ModalSpecial>
  );
};

const WrapperShipmentComponentIndex = ({ order, recordId, refetch, isLoading, onClose }) => {
  const pickup_address_id = useMemo(() => {
    const availables_pickup_address_ids = removeDuplicates(
      (order.order_rows || [])
        .filter(
          ({ product_reference, selected, supplyings }) =>
            selected &&
            have_product_reference(product_reference) &&
            supplyings?.length > 0
        )
        .map(({ supplyings }) =>
          supplyings.map(
            (supplying) =>
              !supplying.used_at && supplying?.supplier?.pickup_address_id
          )
        )
        .flat()
    )?.filter((value) => !!value);
    return availables_pickup_address_ids.at(-1) ?? null;
  }, [order.order_rows]);

  return (
    <ShipmentComponentReturn
      {...order}
      id={recordId}
      refetch={refetch}
      isLoading={isLoading}
      remark={order.shipping_address?.remark || order.remark}
      pickup_address_id={pickup_address_id}
      onClose={onClose}
    />
  );
};

const ReturnItem = ({
  checkedIncluded,
  onChangeChecked,
  record,
  setModalOpt,
  refetch,
  isLoading,
}) => {
  const { order: recordOrder, order_row_returns } = record;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [visible, setVisible] = useState(false);
  const order = useMemo(() => ({
    ...recordOrder,
    order_rows: order_row_returns,
  }), [recordOrder, order_row_returns]);

  function allDeleted(paramRecord) {
    return paramRecord.order_row_returns.every(
      (order_row_return) => order_row_return.deleted_at
    );
  }

  return (
    <TableUi.tr className={"align-middle tableColumn"}>
      <TableUi.td className={"p-left"}>
        <Checkbox checked={checkedIncluded} onChange={onChangeChecked} />
      </TableUi.td>
      <TableUi.td>
        <div
          className="cursor-pointer"
          onClick={() =>
            setModalOpt("order", order.id, {
              id_order: order?.id_order,
            })
          }
        >
          {order?.id_order}
        </div>
      </TableUi.td>
      <TableUi.td>
        <ClientInfoComponent
          client={order?.customer}
          customer={order?.customer}
          shipping_address={order?.shipping_address}
          order_shop={order?.order_shop}
        />
      </TableUi.td>
      <TableUi.td>
        <table className="table-hover table-sm w-full">
          <tbody style={{ fontWeight: "400" }}>
            {record.order_row_returns.map((order_row_return) => {
              return (
                <tr key={order_row_return.id}>
                  <td>
                    <div
                      style={{
                        borderLeft: "2px solid #D9D9D9",
                        paddingLeft: 6,
                      }}
                      className={
                        order_row_return?.deleted_at ? "deleted-goods" : ""
                      }
                    >
                      {order_row_return.order_row?.product_reference ? (
                        <>
                          <span
                            style={
                              order_row_return?.sku !== null
                                ? {
                                  textDecoration: "line-through",
                                  color: "red",
                                }
                                : {}
                            }
                          >
                            [{order_row_return.order_row?.product_reference}]{" "}
                          </span>
                          {order_row_return?.sku !== null && (
                            <span>[{order_row_return.sku}] </span>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {order_row_return.title ||
                        order_row_return.order_row?.product_name}
                    </div>
                  </td>
                  <td className="align-middle">
                    {parseInt(order_row_return.qty)}
                  </td>
                  <td className="align-middle">
                    <div
                      className="text-right"
                      style={{
                        width: 60,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {returnEuroString(
                        order_row_return.price ||
                        order_row_return.order_row?.unit_price_tax_incl
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </TableUi.td>
      <TableUi.td>
        <CourierLinksComponent
          shipments={record.order_row_returns
            .map((order_row_return) =>
              order_row_return.order_row?.shipment_order_rows.map(
                (d) => d.shipment
              )
            )
            .filter((v) => !!v)
            .flat()}
        />
      </TableUi.td>
      <TableUi.td>
        <>
          {record?.shipments?.length > 0 ? (
            <>
              {(() => {
                const shipment = record.shipments[record.shipments.length - 1];
                return (
                  <div>
                    {shipment.api_errors === null && !shipment.delivered_at && (
                      <>
                        {shipment.picked_up_at === null ? (
                          <div>Waiting pick up</div>
                        ) : (
                          <div>Picked up waiting to deliver</div>
                        )}
                      </>
                    )}
                    {formatDateTime(shipment.created_at)}
                    <br />
                    {shipment.tracking_numbers?.length > 0 ? (
                      <>
                        {shipment.tracking_numbers.map(
                          (trackingNumber, idx) => (
                            <div
                              key={idx}
                              onClick={() =>
                                shipment.courier_trackings[idx].url &&
                                window.open(shipment.courier_trackings[idx].url)
                              }
                              style={{
                                backgroundColor: shipment.delivered_at
                                  ? "#28A745"
                                  : "#FFC107",
                                color: shipment.delivered_at
                                  ? "#FFFFFF"
                                  : "#212529",
                                borderRadius: 160,
                                padding: "2px 8px",
                                fontSize: 12,
                                marginTop: "4px",
                                cursor: "pointer",
                              }}
                            >
                              {trackingNumber}
                            </div>
                          )
                        )}
                      </>
                    ) : (
                      <div className="d-flex align-items-center flex-row">
                        {!visible && (
                          <span style={{ color: "#ff0000" }}>
                            {shipment.api_errors}
                          </span>
                        )}
                        {shipment.api_errors && (
                          <>
                            {visible ? (
                              <WrapperShipmentComponentIndex
                                order={order}
                                recordId={record.id}
                                refetch={refetch}
                                isLoading={isLoading}
                                onClose={() => setVisible(false)}
                              />
                            ) : (
                              <div
                                className="btn-primary d-flex justify-content-center align-items-center cursor-pointer"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  minHeight: 30,
                                  borderRadius: "50%",
                                }}
                                onClick={() => {
                                  setVisible(true);
                                }}
                              >
                                <img
                                  src={ShipmentStoreSvg}
                                  style={{
                                    width: 18,
                                    height: 18,
                                    marginLeft: 2,
                                  }}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}
            </>
          ) : (
            <>
              {visible ? (
                <WrapperShipmentComponentIndex
                  order={order}
                  recordId={record.id}
                  refetch={refetch}
                  isLoading={isLoading}
                  onClose={() => setVisible(false)}
                />
              ) : (
                <div
                  className="btn-primary d-flex justify-content-center align-items-center cursor-pointer"
                  style={{ width: 30, height: 30, borderRadius: "50%" }}
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  <img
                    src={ShipmentStoreSvg}
                    style={{ width: 18, height: 18, marginLeft: 2 }}
                  />
                </div>
              )}
            </>
          )}
        </>
      </TableUi.td>
      <TableUi.td>{record.supplier?.name}</TableUi.td>
      <TableUi.td>
        <div className="d-flex flex-column align-items-center">
          {!record.doc_numbers && (
            <button
              className={`btn btn-sm btn-primary rounded-circle ${allDeleted(record) ? "deleted-goods-button" : ""
                }`}
              style={{
                backgroundColor: !!record.doc_numbers
                  ? colors.green
                  : colors.primary,
                borderColor: !!record.doc_numbers
                  ? colors.green
                  : colors.primary,
                width: 32,
                height: 32,
              }}
              disabled={allDeleted(record)}
              onClick={() =>
                setModalOpt("formation_of_document", record.id, {
                  supplier_id: record.supplier_id,
                })
              }
            >
              <HiDocument fill="#fff" />
            </button>
          )}
          {!!record.doc_numbers && (
            <div>
              <div className="badge badge-pill badge-light text-xs px-2 font-normal mt-1">
                <b>Doc. number: </b>
                {record.doc_numbers}
              </div>
            </div>
          )}
        </div>
      </TableUi.td>
      <TableUi.td>
        {capitalizeFirstLetter(record.status).split("_").join(" ")}
      </TableUi.td>
      <TableUi.td>{capitalizeFirstLetter(record.return_type)}</TableUi.td>
      <TableUi.td>
        {!!record.money_refund_item ? (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex align-items-center">
              <IconDot
                className={
                  !!record.money_refund_item?.bank_transaction_id
                    ? "text-success"
                    : "text-danger"
                }
              />
              <span className="pl-2">
                {!!record.money_refund_item?.bank_transaction_id
                  ? "Refunded"
                  : "Not refunded"}
              </span>
            </div>
            {user.role == "admin" && !allDeleted(record) && (
              <button
                className="btn btn-sm btn-primary rounded-circle mt-1"
                style={{
                  backgroundColor: colors.primary,
                  width: 32,
                  height: 32,
                }}
                onClick={() => setModalOpt("refund_module", record.id, record)}
              >
                <IconRollBack />
              </button>
            )}
          </div>
        ) : (
          <button
            className={`btn btn-sm btn-primary rounded-circle ${allDeleted(record) ? "deleted-goods-button" : ""
              }`}
            style={{
              backgroundColor: colors.primary,
              width: 32,
              height: 32,
            }}
            disabled={allDeleted(record)}
            onClick={() => setModalOpt("refund_module", record.id, record)}
          >
            <IconRollBack />
          </button>
        )}
      </TableUi.td>
      <TableComment comments={order.comments} type="comment_ka" />
      <TableComment comments={order.comments} type="comment_management" />
      <TableComment comments={order.comments} type="comment_logistic" />
    </TableUi.tr>
  );
};

const ModalFormationOfDocument = ({ record, order_return_id, onClose }) => {
  const filterString = "?q[m]=or&q[name_eq]=also&q[name_cont_any][]=rivile_";
  const { value: suppliers } = useFetch(
    "/api/v1/suppliers" + filterString,
    {},
    [],
    (value) => {
      return value.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
    }
  );

  const [form] = Form.useForm();

  const mutationPUT = useMutation({
    mutationFn: (value) =>
      Axios.put(`/api/v1/order_returns/${order_return_id}`, {
        order_return: value,
      }).then((res) => res.data),
    onSuccess: (response) => {
      if (response.success) {
        queryLostCartsClient
          .getQueryCache()
          .findAll(["order_returns"])
          .forEach(({ queryKey }) => {
            queryLostCartsClient.setQueryData(queryKey, (prev) => {
              return {
                ...prev,
                data: prev.data.map((s) =>
                  s.id == response.data.id ? { ...s, ...response.data } : s
                ),
              };
            });
          });
      }
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      const errorData = error?.response?.data?.errors;
      if (errorData) {
        for (const key in errorData) {
          if (errorData.hasOwnProperty(key)) {
            errorData[key].forEach((errorMessage) => {
              antdMessageError(errorMessage);
            });
          }
        }
      } else {
        antdMessageError(error?.response?.data?.message);
      }
    },
  });

  return (
    <ModalSpecial
      style={{
        width: 300,
      }}
      text={
        <span className="d-flex align-items-center justify-content-between w-100">
          <div>
            <span className="font-bold text-xl text-black">Return</span>
            <span className="font-bold text-xl text-primary pl-1">#</span>
            <span className="font-bold text-xl text-black pr-1">
              {order_return_id}
            </span>
            <span className="font-bold text-xl text-black">
              document formation
            </span>
          </div>
        </span>
      }
      onClose={() => {
        onClose();
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        initialValues={{ supplier_id: record?.supplier_id }}
        onFinish={(values) => {
          mutationPUT.mutate(values);
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Division"
          name="supplier_id"
          rules={[
            {
              required: true,
              message: "Can't be empty",
            },
          ]}
        >
          <Select placeholder="Select" showSearch optionFilterProp="children">
            {suppliers?.map((s) => (
              <Select.Option key={s.value} {...s}>
                {s.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutationPUT.isLoading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

const ReturnsPageWrapper = ({ match }) => {
  return (
    <QueryClientProvider client={queryLostCartsClient}>
      <ReturnsPage match={match} />
    </QueryClientProvider>
  );
};

export default ReturnsPageWrapper;

const generateParams = (filters = {}, comment_states = []) => {
  let filtStr = Object.entries(filters)
    .filter(([key, value]) => {
      if (!value) return false;

      if (key === "lost_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.length > 0;
      }

      if (typeof value === "string") {
        value = value.trim();
        return value.length > 0;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return typeof value === "string";
    })
    .map(([key, value]) => {
      if (key === "lost_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.join("&");
      }
      if (key == "comment_states") {
        const filters = [];
        value.forEach((item) => {
          const comment_state = comment_states.find((s) => s.id == item);
          if (comment_state) {
            filters.push(`q[${comment_state.comment_type}_id_in][]=${item}`);
          }
        });
        return filters.join("&");
      }

      if (key === "logistic_comments_body_cont") {
        return `q[order_comments_body_cont]=${value}&q[order_comment_type_eq]=comment_logistic`;
      }

      if (key.includes("_in")) {
        const filters = [];
        value.forEach((item) => {
          filters.push(`q[${key}][]=${item}`);
        });
        return filters.join("&");
      }

      return `q[${key}]=${value}`;
    })
    .join("&");
  if (filtStr !== "") {
    filtStr = "&" + filtStr;
  }
  return filtStr;
};
